export const Loading = (element, loading, initial, template, data) => {
  const el = document.getElementById(element.id);
  const existingLoader = document.getElementById(`onschedjs-loader-${element.id}`);
  
  var loader;
  
  if (el) {
    if (loading) {
      if (initial) {
        el.classList.add('loading');
        el.classList.add('initial-load');
      }
      else {
        el.classList.add('loading');
      }

      if (!existingLoader) {
        loader = document.createElement('DIV');

        loader.className = 'OnSchedJs-Loader';
        loader.id = `onschedjs-loader-${element.id}`;
        loader.style.width = el.clientWidth + 'px';
        loader.innerHTML = template && LoadingTemplates(data)[template] ? LoadingTemplates(data)[template] : '';
        
        el.append(loader)
      }
    }
    else {
      el.classList.remove('loading');

      if (el.classList.contains('initial-load')) {
        el.classList.remove('initial-load');
      }

      if (existingLoader) {
        existingLoader.remove();
      }
    }
  }
}


const LoadingTemplates = (data) => ({
  Availability: `
    <div class="lds-ellipsis" ${data?.calendarType !== 'week' ? 'style="margin-left: calc(50% - 40px);margin-top: 218.5px;"' : ''}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  `,
  List: `
    <div class="loader-template-item" style="${data?.search === true ? 'margin: 41px 0;' : 'margin:10px 0;'}background-color:transparent;border-radius:4px;height:38px;width:100%;"></div>
    <div class="loader-template-item" style="background-color:#f9f9fb;border-radius:4px;height:38px;width:100%;margin:10px 0;"></div>
    <div class="loader-template-item" style="background-color:#f9f9fb;border-radius:4px;height:38px;width:100%;margin:10px 0;"></div>
    <div class="loader-template-item" style="background-color:#f9f9fb;border-radius:4px;height:38px;width:100%;margin:10px 0;"></div> 
  `,
})
